import { gql } from '@apollo/client';
import { graphqlClient } from 'spw-api/utils';
import {
  ICluster,
  IFloorplanPoint,
  ISpace,
} from 'spw-redux/modules/floorplan/types';
import { SPACE_FIELDS } from 'spw-api/esa_fragments';

export const updateClusterApi = (cluster: Partial<ICluster>) =>
  graphqlClient.mutate<{ updateCluster: ICluster }>({
    mutation: gql`
      mutation UpdateCluster($cluster: ClusterArgs!) {
        updateCluster(cluster: $cluster) {
          id
          number
          roomName
          seatCount
          usf
          notes
          floorplanPoint {
            x
            y
          }
          projectSpaceType {
            id
            spaceType {
              id
              name
              isCustom
            }
            category {
              id
              name
              icon
              defaultSpaceTypeCategory {
                id
                name
                category
              }
              parentId
            }
          }
          spaceType {
            id
            name
            spaceType
            spaceTypeCategory {
              id
              category
            }
          }
        }
      }
    `,
    variables: { cluster },
  });

export const createSpaceFromClusterApi = (
  clusterId: number,
  floorplanPoint: IFloorplanPoint
) => {
  return graphqlClient.mutate<{
    clusterAndSpace: { cluster: ICluster; space: ISpace };
  }>({
    mutation: gql`
      ${SPACE_FIELDS}
      mutation CreateSpaceFromCluster(
        $clusterId: ID!
        $floorplanPoint: InputPoint!
      ) {
        clusterAndSpace: createSpaceFromCluster(
          clusterId: $clusterId
          floorplanPoint: $floorplanPoint
        ) {
          cluster {
            id
          }
          space {
            ...SpaceFields
          }
        }
      }
    `,
    variables: {
      clusterId,
      floorplanPoint,
    },
  });
};
